module.exports = __webpack_public_path__ + "public/img/duoshanghu.4c3eb194.png";